import classes from './StatusMenu.module.sass'
import edit from '../../../assets/images/icons/edit.svg'
import more from '../../../assets/images/icons/more.svg'
import { useStatusMenu } from './hooks/useStatusMenu'
import {
  CargoItemInterface,
  SlotItemInterface,
  TransportItemInterface,
} from '../../types/interfaces'
import { NavLinks } from '../navLinks/NavLinks'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../../../store/slices/currentUserSlice'
import Share from '../share/Share'
import { Selected } from '../selected/Selected'
import { IconButton } from './../iconButton/IconButton'
import { StatusComponent } from '../statusComponent/StatusComponent'
import { Status } from '../../types/enums'
import { MenuItem } from './components/menuItem/MenuItem'
import stop from '../../../assets/images/icons/stop.svg'
import play from '../../../assets/images/icons/play.svg'
import pause from '../../../assets/images/icons/pause.svg'
import trash from '../../../assets/images/icons/trash.svg'
import archive from '../../../assets/images/icons/archive.svg'
import restore from '../../../assets/images/icons/restore.svg'
import done from '../../../assets/images/icons/done.svg'
import error from '../../../assets/images/icons/error.svg'
import { selectDarkTheme } from '../../../store/slices/settingsSlice'

type Props = {
  item: SlotItemInterface | TransportItemInterface | CargoItemInterface
  selectedClick: () => void
  selected: boolean
}

export const StatusMenu = ({ item, selectedClick, selected }: Props) => {
  const { updateStatus, startEdit, statusMenuActive, toggleExpanded } = useStatusMenu(item)
  const currentUser = useSelector(selectCurrentUser)
  const darkTheme = useSelector(selectDarkTheme)

  return (
    <div className={classes.Container}>
      <div className={classes.Group}>
        <Selected
          visible={Boolean(currentUser && currentUser.id !== item.userId)}
          selected={selected}
          onClick={selectedClick}
        />

        {currentUser && item.points && item.points?.length > 1 && (
          <NavLinks
            google_route_url={item.google_route_url}
            yandex_route_url={item.yandex_route_url}
            double_gis_route_url={item.double_gis_route_url}
          />
        )}
      </div>

      <StatusComponent item={item} />

      <div className={classes.Group}>
        {item.userId === currentUser?.id && item.status === Status.POSTPONED && (
          <IconButton small icon={edit} alt="Редактировать" onClick={startEdit} display />
        )}
        <Share order={item} />
        <div>
          {(currentUser?.id === item.userId || currentUser?.id === item.executorId) &&
            item.status !== Status.DELETED && (
              <IconButton
                display
                small
                icon={more}
                onClick={toggleExpanded}
                alt="Больше действий"
              />
            )}
          {statusMenuActive && (
            <div className={classes.Anchor}>
              <div className={!darkTheme ? classes.MenuContainer : classes.MenuContainerDark}>
                <MenuItem
                  visible={
                    item.status !== Status.CANCELED &&
                    item.status !== Status.DELETED &&
                    item.status !== Status.ARCHIVED &&
                    item.status !== Status.DISRUPTED &&
                    item.status === Status.IN_WORK &&
                    currentUser?.id === item.userId
                  }
                  text="отменить"
                  icon={stop}
                  onClick={() => {
                    if (item.id) updateStatus(item.id, Status.CANCELED)
                  }}
                />
                <MenuItem
                  visible={
                    item.status !== Status.NEW &&
                    item.status !== Status.DELETED &&
                    item.status !== Status.IN_WORK &&
                    item.status !== Status.DISRUPTED
                  }
                  text="опубликовать"
                  icon={play}
                  onClick={() => {
                    if (item.id) updateStatus(item.id, Status.NEW)
                  }}
                />
                <MenuItem
                  visible={item.status === Status.NEW || item.status === Status.ARCHIVED}
                  text="снять/отложить"
                  icon={pause}
                  onClick={() => {
                    if (item.id) updateStatus(item.id, Status.POSTPONED)
                  }}
                />
                <MenuItem visible={false} text="повторить" icon={restore} onClick={() => {}} />

                <MenuItem
                  visible={item.status === Status.IN_WORK}
                  text="завершить"
                  icon={done}
                  onClick={() => {
                    if (item.id) updateStatus(item.id, Status.COMPLETED)
                  }}
                />
                <MenuItem
                  visible={item.status === Status.IN_WORK}
                  text="Сорван"
                  icon={error}
                  onClick={() => {
                    if (item.id) updateStatus(item.id, Status.COMPLETED)
                  }}
                />

                <MenuItem
                  visible={
                    item.status !== Status.ARCHIVED &&
                    item.status !== Status.DELETED &&
                    item.status !== Status.IN_WORK
                  }
                  text="в архив"
                  icon={archive}
                  onClick={() => {
                    if (item.id) updateStatus(item.id, Status.ARCHIVED)
                  }}
                />
                <MenuItem
                  visible={item.status !== Status.DELETED && item.status !== Status.IN_WORK}
                  text="удалить"
                  icon={trash}
                  onClick={() => {
                    if (item.id) updateStatus(item.id, Status.DELETED)
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
